import React, { useEffect } from "react";
import { Box, Divider, Stack, Typography } from "digiwash-components";

import PageContainer from "../components/PageContainer";

import Header from "../components/AppHeader";

import HeaderWorkspace from "../components/HeaderWorkspace";
import Categories from "../containers/Categories/Categories-container";
import { useCategories } from "../hooks/useCategories";
import ContactUs from "../components/ContactUs";
import SkeletonCategories from "../components/SkeletonCategories/SkeletonCategories";
import SkeletonPopularServices from "../components/SkeletonPopularServises/SkeletonPopularServices-component";
import BasketFloatButton from "../components/BasketFloatButton";
import ServerError from "../components/ServerError";
import OrderItem from "../components/OrderItem";
import useOrdersNeedsActionList from "../ducks/user/hooks/useOrdersNeedsActionList";
import { useSelector } from "react-redux";
import userSelectors from "../ducks/user/selectors";
import { Helmet } from "react-helmet";
import useFocusEffect from "../hooks/useFocusEffect";
import PopularServices from "../components/PopularServices";
import DigiwashServicesSection from "../components/DigiwashServicesSection";
import Video from "../components/Video";
import { useHomePageContent } from "../hooks/useHomePageContent";
import Loading from "../components/Loading";
import { usePopularServices } from "../hooks/usePopularServices";
import HeaderContainer from "../containers/HeaderContainer";
import { useListenToDeepLinks } from "../hooks/useListenToDeepLinks";
import Banner from "../components/Banner";
import Popup from "../components/Popup";
import { Platform } from "react-native";
import { useForceUpdate } from "../hooks/useForceUpdate";
import BannerNotice from "../components/BannerNotice/BannerNotice-component";

function HomeNewPage() {
  useListenToDeepLinks();
  let { retrive, categoriesData, loading, error } = useCategories();

  let {
    retrive: retrievePopularServices,
    data: popularServicesData,
    loading: popularServicesLoading,
    error: popularServicesError,
  } = usePopularServices();

  let {
    retrieve: homePageContentRetrieve,
    data: homePageContentData,
    error: homePageContentError,
    loading: homePageContentLoading,
  } = useHomePageContent();
  let { data: activeOrders, revalidate: revalidateOrdersNeedsAction } =
    useOrdersNeedsActionList();
  let hasWorkDone = activeOrders !== undefined && activeOrders.length > 0;
  let isAuthenticated: boolean = useSelector(userSelectors.getToken);

  useEffect(() => {
    retrive();
    homePageContentRetrieve();
    retrievePopularServices();
    if (isAuthenticated) {
      revalidateOrdersNeedsAction();
    }
  }, []);

  // useEffect(() => {
  //   if (!!isAuthenticated && !!profileData?.first_name) {
  //     window.Raychat?.setUser({
  //       name: `${profileData.first_name} ${profileData.last_name}`,
  //       phone: profileData.cellphone,
  //       updateOnce: true,
  //     });
  //   }
  // }, []);
  // useEffect(() => {
  //   if (!!isAuthenticated && !!profileData?.first_name) {
  //     window.Raychat?.setUser({
  //       name: `${profileData.first_name} ${profileData.last_name}`,
  //       phone: profileData.cellphone,
  //       updateOnce: true,
  //     });
  //   }
  // }, [profileData?.first_name]);

  if (Platform.OS === "android") {
    useForceUpdate(homePageContentData?.appInfo[0]);
  }

  return (
    <>
      <Helmet>
        <title>خشکشویی دیجی واش</title>
      </Helmet>
      <PageContainer
        showBottomNavigation
        insideBeignScrollView={
          <HeaderContainer>
            <Header />
          </HeaderContainer>
        }
        afterScrollView={
          isAuthenticated && (
            <>
              <BasketFloatButton extraSpaceFromBottom={true} />
            </>
          )
        }
      >
        <Box>
          <HeaderWorkspace />
          <Divider size="l" />
          <Box px="xxl">
            {!!homePageContentData && !!homePageContentData.promotions
              ? homePageContentData.promotions.map((item) => {
                  return item.description ? (
                    <>
                      <BannerNotice text={item.description} />
                      <Divider size="xxl" />
                    </>
                  ) : null;
                })
              : null}
          </Box>
          {homePageContentData && homePageContentData?.appInfo[0] ? (
            <Box px="xxl">
              <ContactUs phone={homePageContentData.appInfo[0].phone} />
            </Box>
          ) : null}

          <Box px="xxl">
            <Divider size="xxl" />
            <Typography ff="mainBold" fs="l" color="common.black">
              خدمات دیجی واش
            </Typography>
            <Divider size="xxxl" />
            <Box px="l">
              <DigiwashServicesSection />
            </Box>
          </Box>
          <Divider size="xxl" />
          {!!homePageContentData && !!homePageContentData.promotions
            ? homePageContentData.promotions.map((item) => {
                return item.url ? (
                  <>
                    <Banner
                      url={item.url}
                      ratio={item.ratio}
                      code={item.code}
                    />
                    <Divider size="xxl" />
                  </>
                ) : null;
              })
            : null}

          <Box px="xxl">
            <Box>
              {hasWorkDone
                ? activeOrders.map((item) => {
                    return (
                      <>
                        <OrderItem data={item} />
                        <Divider size="l" />
                      </>
                    );
                  })
                : null}
            </Box>
            <Box style={{ height: 206 }} br="s" p="xm" bg="gray.bg">
              <Typography ff="mainBold" fs="l" color="common.black">
                خدمات محبوب
              </Typography>
              {popularServicesLoading ? (
                <>
                  <Divider size="l" />
                  <SkeletonPopularServices />
                </>
              ) : null}
              {!popularServicesLoading && popularServicesError ? (
                <>
                  <Divider size="l" />
                  <Stack distribution="center" pt="xxxl">
                    <Typography color="common.black" alignment="center">
                      {popularServicesError}
                    </Typography>
                  </Stack>
                </>
              ) : null}
              {!popularServicesLoading && !!popularServicesData?.data ? (
                <>
                  <Divider size="xm" />
                  <PopularServices
                    data={popularServicesData.data.listPopularServices}
                  />
                </>
              ) : null}
            </Box>
            <Divider size="xxxl" />
            <Box>
              <Typography ff="mainBold" fs="l" color="common.black">
                دسته‌بندی خدمات
              </Typography>

              {loading && (
                <Box>
                  <SkeletonCategories />
                </Box>
              )}
              {error && (
                <>
                  <Divider size="xxxl" />
                  <ServerError error={error} action={() => retrive()} />
                </>
              )}
              {categoriesData && !loading && !error ? (
                <Categories data={categoriesData?.data?.listCategories} />
              ) : null}
            </Box>

            <Divider size="xxxl" />
            {homePageContentLoading ? <Loading color="primary.main" /> : null}
            {!homePageContentLoading && homePageContentError ? (
              <>
                <Divider size="xxl" />
                <Stack distribution="center">
                  <Typography>{homePageContentError}</Typography>
                </Stack>
              </>
            ) : null}
            {/* {!homePageContentLoading && !!homePageContentData ? (
              <>
                <Box>
                  <Divider line="gray.lighter" />
                  <Divider size="xxl" />
                  <Video data={homePageContentData.videos} />
                </Box>
                <Divider size="xxl" />
              </>
            ) : null} */}
            <Divider size="huge" />
          </Box>
        </Box>
      </PageContainer>
      {homePageContentData?.promotionNewUsers[1]?.code ? (
        <Popup url={homePageContentData?.promotionNewUsers[1]?.code} />
      ) : null}
    </>
  );
}

export default HomeNewPage;
